export const PAGE_VERTICAL_PADDING = 24
